import React, { SVGProps } from "react";

export default function SupNotifications(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 11V7.5C15.267 5.40314 13.7741 3.72413 11.8264 3.1837C11.5141 2.48606 10.8138 2 10 2C9.1862 2 8.48592 2.48606 8.17363 3.1837C6.22594 3.72413 4.73298 5.40314 4.5 7.5V11L3 13V15.5H17V13L15.5 11ZM8.441 4.14729L8.8942 4.02154L9.08635 3.59227C9.24347 3.24128 9.59464 3 10 3C10.4054 3 10.7565 3.24128 10.9136 3.59227L11.1058 4.02154L11.559 4.14729C13.106 4.57654 14.2945 5.9013 14.5 7.5584V11.3333L16 13.3333V14.5H4V13.3333L5.5 11.3333V7.5584C5.70549 5.9013 6.89402 4.57654 8.441 4.14729Z"
        fill="currentColor"
      />
      <path
        d="M12 16C12 16.3643 11.9026 16.7058 11.7324 17C11.3866 17.5978 10.7403 18 10 18C9.25972 18 8.61337 17.5978 8.26756 17C8.09739 16.7058 8 16.3643 8 16H12Z"
        fill="currentColor"
      />
    </svg>
  );
}
